import { render } from "./side-panel-district.vue?vue&type=template&id=f6a63714&scoped=true"
import script from "./side-panel-district.vue?vue&type=script&lang=js"
export * from "./side-panel-district.vue?vue&type=script&lang=js"

import "./side-panel-district.vue?vue&type=style&index=0&id=f6a63714&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a63714"],['__file',"src/components/admin-dashboard/panels/side-panel-district.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6a63714"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6a63714', __exports__)) {
    api.reload('f6a63714', __exports__)
  }
  
  module.hot.accept("./side-panel-district.vue?vue&type=template&id=f6a63714&scoped=true", () => {
    api.rerender('f6a63714', render)
  })

}


export default __exports__